/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
// ES6 Modules or TypeScript
// import Swal from 'sweetalert2'
export default {
  async UPDATE_TOKEN(state) {
    var tk = localStorage.getItem("token");
    var tkpaser = JSON.parse(tk);
    state.apiHeader = {
      headers: {
        Authorization: "bearer " + tkpaser
      }
    };

    // console.log(" (1) @@@@@ MUTATION UPDATE_TOKEN");
  },

  UPDATE_AUTHENTICATED_USER(state, user) {
    state.currentUser = user.username;
    state.currentUserImage = user.image;
    // console.log(" (1) @@@@@ MUTATION UPDATE_AUTHENTICATED_USER >>> ",user);
    localStorage.setItem("userInfo", JSON.stringify(user));

    // localStorage.setItem("userRole", "admin");
  },

  SET_USER_IMAGE(state, img) {
    state.currentUserImage = img;
    // console.log('AUTH MUTUATION >>>> ',img);


  },
  SHOP_PACKAGE(state, pkg) {
    state.currentPackage = pkg;
    // console.log('@@@@@@ AUTH MUTUATION >>>> ',state.currentPackage );


  },

  async UPDATE_ROLES(state, payload) {
    // console.log('@@@@@@@@@@@@ UPDATE_ROLES @@@@@@@@@@@@@@');

    var pm = payload.roles.filter(
      x =>
      x.roleName === "owner" ||
      x.roleName === "admin" ||
      x.roleName === "accountingadmin" ||
      x.roleName === "useradmin"
    );

    var permission = "staff";
    if (pm.length >= 1) {
      permission = "admin";
    } else {
      permission = "staff";
    }




    // ***** เลือก BRANCH
    var branch_th = "1";
    var cb = [];

    if (payload.allbranches !== undefined && payload.allbranches !== null) {
      // หา main branch
      cb = payload.allbranches.filter(x => x.flag1 === "m");

    }

    if (cb.length <= 0) {
      cb[0] = "";
    }
    if (payload.branches.length <= 0) {
      payload.branches[0] = "";
    }


    // console.log('@@@@@@@@UPDATE_ROLES 2222 >>>> ',permission);

    var currentBranch;
    var mybranchid ;
    var myBranches;

    // รวมกรณี admin ทั้งหลาย
    if (permission === "admin") {
      currentBranch = cb[0];
      mybranchid = cb[0].branchId;
      myBranches = payload.allbranches;

      // console.log('@@@ permission === "admin" >>>> ', payload.allbranches);


    } else {
      // หา branch ของ staff
      if (payload.branches.length > 0) {
        mybranchid = payload.branches[0].branchId;
        currentBranch = payload.branches[0];
        myBranches = payload.branches;

      } else {
        // console.log('cb[0] >>>>>>>>>>> ', cb[0]);
        currentBranch = cb[0];
        mybranchid = cb[0].branchId;
        myBranches = cb;
      }
    }

    if(state.currentBranch === null || state.currentBranch === undefined)
    {
      state.mybranchid = mybranchid;
      state.myBranches = myBranches;
      state.currentBranch = currentBranch;
    }

    state.mybranch = branch_th;
    state.roles = payload.roles;
    state.permission = permission;
    // console.log("@@@@@UPDATE_ROLES  BRANCHES ID >>> ", state.mybranchid);
    // console.log("@@@@@UPDATE_ROLES  CURRENT BRANCHES  >>> ", state.myBranches);
    // console.log("@@@@@UPDATE_ROLES store.state.auth.roles >>> ", state.roles);
  },

  async CHANGE_CURRENT_BRANCH(state, payload) {

  //  console.log('START!!!!! payload', payload);

   var pm = payload.roles.filter(
    x =>
    x.roleName === "owner" ||
    x.roleName === "admin" ||
    x.roleName === "accountingadmin" ||
    x.roleName === "useradmin"
  );

  var permission = "staff";
  if (pm.length >= 1) {
    permission = "admin";
  } else {
    permission = "staff";
  }



  // ***** เลือก BRANCH
  // var branch_th = "1";
  var cb = [];

  var mainBranch = [];

  if (payload.allbranches !== undefined && payload.allbranches !== null) {
    // หา main branch
    mainBranch = payload.allbranches.filter(x => x.flag1 === "m");
  }

  // if (cb.length <= 0) {
  //   cb[0] = "";
  // }
  // if (payload.branches.length <= 0) {
  //   payload.branches[0] = "";
  // }


console.log('BEFORE IFFFFFFFFF >>>> ', payload);
  // *** รวมกรณี admin ทั้งหลาย เปลี่ยนสาขาไหนก็ได้
  if (permission === "admin") {
    // *** เปลี่ยนสาขาไหนก็ได้ allbranches
    cb = payload.allbranches.filter(x => x.branchId === payload.selectedBranchId);
    if(cb.length <= 0){
      // Swal.fire({
      //   icon: 'warning',
      //   title: 'ไม่สามารถเปลี่ยนสาขาได้ ลอง refresh browser อีกครั้ง',
      // });
      return;
    }

    state.currentBranch = cb[0];
    state.mybranchid = cb[0].branchId;
    state.myBranches = payload.allbranches;

    // console.log('@@@ permission === "admin" >>>> ', payload.allbranches);


  } else {
    // console.log('@@@ ELSE IN CASE STAFF >>>> ');
    // *** กรณีของ staff ต้องเช็คก่อนว่า สังกัดใน branch หรือไม่
    // console.log('@@@ permission === "staff" >>>> ', payload.selectedBranchId);
    // console.log('@@@ payload.branches >>>> ',payload.branches);
    if (payload.branches.length > 0) {
      cb = payload.branches.filter(x => x.branchId === payload.selectedBranchId);
      console.log('@@@ IF payload.selectedBranchId >>>> ', payload.selectedBranchId);
      if(cb.length <= 0){
        // Swal.fire({
        //   icon: 'warning',
        //   title: 'ไม่สามารถเปลี่ยนสาขาได้ ลอง refresh browser อีกครั้ง',
        // });
        return;
      }

      console.log('@@@ CB[0] ', cb);
      state.mybranchid = cb[0].branchId;
      state.currentBranch = cb[0];
      state.myBranches = payload.branches;

    } else {
      // console.log('cb[0] >>>>>>>>>>> ', cb[0]);
      console.log('@@@ ELSE payload.selectedBranchId >>>> ', payload.selectedBranchId);
      state.currentBranch = mainBranch[0];
      state.mybranchid = mainBranch[0].branchId;
      state.myBranches = payload.branches;

    }
  }

  // state.mybranch = branch_th;
  state.roles = payload.roles;
  state.permission = permission;
  // console.log("@@@@@UPDATE_ROLES  currentBranch ID >>> ", state.currentBranch);
  // console.log("@@@@@UPDATE_ROLES  MY BRANCHES  >>> ", state.myBranches);
  // console.log("@@@@@UPDATE_ROLES store.state.auth.roles >>> ", state.roles);

  },

  USER_LOGIN_SUCCESS(state) {
    state.isAuthen = true;
  },
  USER_LOGIN_FAILED(state) {
    // this.$swal("Cancelled", "Your imaginary file is safe :)", "error");

    state.isAuthen = false;
  },
  USER_LOGOUT(state) {
    state.myBranches = [];
    // state.currentBranch = null;
    // state.mybranchid= null
    state.isAuthen = false;
  }
};
